import { createFileRoute } from '@tanstack/react-router';

import { filterState, TabularPageLoadingLayout } from '@/_containers';
import { getMarketingCampaignAllQueryOptions } from '@/_pages/marketing-campaigns/api-service';

export const Route = createFileRoute('/_private/marketing-campaigns/')({
  validateSearch: filterState.parse,
  staticData: { isFullWidth: true },
  loader: (opts) => opts.context.queryClient.ensureQueryData(getMarketingCampaignAllQueryOptions()),
  pendingComponent: () => <TabularPageLoadingLayout numberOfColumns={5} />,
});
